import './ChartContextInfo.scss';
import './chart-tooltip.scss';
import { ChartConfig } from '@blisspointmedia/bpm-types/dist/dashboarding';
import { InfoTooltip } from '@Components/InfoTooltip';
import { Placement } from '@Components/designConstants';
import { buildChartSourceSegments } from './chart-context-line-utils';

interface ChartContextInfoProps {
  config: ChartConfig;
  // Set when this renders as part of a title's own wrapping text (e.g. trailing a line-clamped
  // title) rather than as a flex/grid item beside it — see InfoTooltip's `inline` prop.
  inline?: boolean;
}

// A compact info affordance for where a chart's numbers come from — channel/source context —
// revealed on hover. The chart's filters are shown as a line under the title instead (see
// ChartFilterLine). No color/size override: InfoTooltip's own defaults (purple, large) are what
// every other info tooltip in the app looks like.
export const ChartContextInfo = ({ config, inline = false }: ChartContextInfoProps) => {
  const segments = buildChartSourceSegments(config.queries);
  if (segments.length === 0) return undefined;

  return (
    <InfoTooltip
      placement={Placement.BOTTOM_START}
      popoverClassName='chart-tooltip'
      aria-label='Chart data context'
      inline={inline}
    >
      <div className='chart-context-info-tooltip'>
        {segments.map(segment => (
          <div key={segment}>{segment}</div>
        ))}
      </div>
    </InfoTooltip>
  );
};
